<template>
  <v-row dense>
    <v-col>
      <v-row dense>
        <v-col v-if="hideTitle" />
        <v-col v-else-if="shard.title === 'hidden'" class="mb-6" />

        <v-col
          v-else
          :class="[
            depth > 0 ? 'text-subtitle-2 gray--text text--lighten-1' : 'text-h5 gray--text',
          ]"
        >
          <v-row no-gutters justify="space-between">
            <v-col>
              {{ shard.title }}
            </v-col>

            <v-col cols="auto">
              <slot name="useButton" v-bind:shard="shard"> </slot>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <DynamicFormConsolidatedInfo
        v-if="showConsolidateInfo"
        :consolidatedInfo="consolidatedInfo"
        :consolidateInfoOption="consolidateInfoOption"
      />

      <v-row dense v-if="showMean || showVariance">
        <v-col>
          <v-row dense v-if="showMean">
            <v-col>
              <v-row>
                <v-col class="text-subtitle-2 gray--text text--lighten-1">Média</v-col>
              </v-row>

              <DynamicFormArithmetic :info="shard.mean" />
            </v-col>
          </v-row>
        </v-col>

        <v-col>
          <v-row dense v-if="showVariance">
            <v-col>
              <v-row>
                <v-col class="text-subtitle-2 gray--text text--lighten-1">Variancia</v-col>
              </v-row>

              <DynamicFormArithmetic :info="shard.variance" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row dense v-if="!lodash.isEmpty(fields)">
        <DynamicFormField
          v-for="field in fields"
          :key="`${answerableId}-${currentAnswerGroupId}-${field.id}`"
          :field="field"
          :readOnly="readOnly"
          :answerGroup="currentAnswerGroup"
          :createAnswerGroup="debouncedCreateAnswerGroups"
          :saveAnswer="saveAnswer"
        />

        <v-col v-if="showDutyCycle">
          <v-row dense align="end" class="fill-height">
            <v-col class="pt-0">
              <v-text-field
                :value="dutyCycleDuration"
                label="Duração"
                placeholder=" "
                disabled
                dense
                hide-details
                suffix="ms"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col v-if="showDutyCycle">
          <v-row dense align="end" class="fill-height">
            <v-col class="pt-0">
              <v-text-field
                :value="dutyCycleInterval"
                label="Intervalo"
                placeholder=" "
                disabled
                dense
                hide-details
                suffix="ms"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row dense v-if="showPresetButtons && !(showAddButton && showPresetButtons)">
        <v-col v-for="preset in presets" :key="preset.id" cols="auto">
          <v-btn
            color="gray lighten-1"
            dark
            small
            @click="activePreset({ presetId: preset.id })"
          >
            {{ preset.name }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row dense v-if="!lodash.isEmpty(links) && showChildrenAsTabs">
        <v-col>
          <v-tabs
            v-model="tabNavigation"
            show-arrows
            background-color="transparent"
            color="light-blue"
          >
            <v-tab v-for="link in links" :key="`tab-${link.id}`">
              {{ link.shard.title }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tabNavigation" :style="{ backgroundColor: 'transparent' }">
            <v-tab-item
              eager
              v-for="link in links"
              :key="`tab-${currentAnswerGroupId}-${link.id}`"
            >
              <v-row dense>
                <DynamicFormLink
                  :answerableId="answerableId"
                  :answerableType="answerableType"
                  :link="link"
                  :depth="depth + 1"
                  :hideTitle="true"
                  :readOnly="readOnly"
                  :parentAnswerGroup="currentAnswerGroup"
                  :parentCreateAnswerGroup="debouncedCreateAnswerGroups"
                  :refreshForm="refreshForm"
                />
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>

      <v-row dense v-if="!lodash.isEmpty(links) && !showChildrenAsTabs">
        <DynamicFormLink
          v-for="link in links"
          :key="`${currentAnswerGroupId}-${link.id}`"
          :answerableId="answerableId"
          :answerableType="answerableType"
          :readOnly="readOnly"
          :depth="depth + 1"
          :link="link"
          :parentAnswerGroup="currentAnswerGroup"
          :parentCreateAnswerGroup="debouncedCreateAnswerGroups"
          :refreshForm="refreshForm"
        />
      </v-row>

      <v-row dense v-if="showAddButton && !(showAddButton && showPresetButtons)">
        <v-col cols="auto">
          <v-btn color="light-blue" dark small @click="debouncedCreateAnswerGroups">
            Adicionar
          </v-btn>
        </v-col>

        <v-col cols="auto">
          <v-btn
            dark
            small
            color="red"
            @click="deleteAnswergroup({ answerGroupId: currentAnswerGroupId })"
          >
            limpar
          </v-btn>
        </v-col>
      </v-row>

      <v-row dense v-if="showAddButton && showPresetButtons">
        <v-col cols="auto">
          <v-btn color="light-blue" dark small @click="debouncedCreateAnswerGroups">
            Adicionar
          </v-btn>
        </v-col>

        <v-col cols="auto">
          <v-btn
            dark
            small
            color="red"
            @click="deleteAnswergroup({ answerGroupId: currentAnswerGroupId })"
          >
            limpar
          </v-btn>
        </v-col>

        <v-col v-for="preset in presets" :key="preset.id" cols="auto">
          <v-btn
            color="gray lighten-1"
            dark
            small
            @click="activePreset({ presetId: preset.id })"
          >
            {{ preset.name }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row dense v-for="oldAnswerGroup in oldAnswerGroups" :key="`${oldAnswerGroup.id}`">
        <v-col>
          <v-card>
            <v-container fluid>
              <v-row dense justify="end" v-if="!readOnly">
                <v-col cols="auto">
                  <v-btn
                    x-small
                    text
                    @click="deleteAnswergroup({ answerGroupId: oldAnswerGroup.id })"
                  >
                    Excluir
                  </v-btn>
                </v-col>
              </v-row>

              <v-row dense>
                <DynamicFormField
                  v-for="field in fields"
                  :key="`old-${oldAnswerGroup.id}-${field.id}`"
                  :readOnly="true"
                  :field="field"
                  :answerGroup="oldAnswerGroup"
                  :createAnswerGroup="debouncedCreateAnswerGroups"
                  :saveAnswer="saveAnswer"
                />

                <DynamicFormLink
                  v-for="link in links"
                  :key="link.id"
                  :answerableId="answerableId"
                  :answerableType="answerableType"
                  :link="link"
                  :depth="depth + 1"
                  :readOnly="true"
                  :parentAnswerGroup="oldAnswerGroup"
                  :parentCreateAnswerGroup="debouncedCreateAnswerGroups"
                  :refreshForm="refreshForm"
                />
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import CREATE_DYNAMIC_FORM_ANSWER_GROUP from "@/graphql/dynamic_form/create_answer_group.gql";
  import ACTIVE_PRESET from "@/graphql/dynamic_form/active_preset.gql";
  import DELETE_DYNAMIC_FORM_ANSWER_GROUP from "@/graphql/dynamic_form/delete_answer_group.gql";

  import DynamicFormField from "@/components/dynamic_form/field.vue";
  import DynamicFormConsolidatedInfo from "@/components/dynamic_form/shard/consolidated_info.vue";
  import DynamicFormArithmetic from "@/components/dynamic_form/shard/arithmetic.vue";

  export default {
    name: "DynamicFormShard",
    props: {
      answerableId: String,
      answerableType: String,
      shard: Object,
      readOnly: Boolean,
      hideTitle: Boolean,
      depth: Number,
      parentAnswerGroup: {
        type: Object,
        default: null,
      },
      parentCreateAnswerGroup: {
        type: Function,
        default: null,
      },
      refreshForm: Function,
    },
    components: {
      DynamicFormLink: () => import("@/components/dynamic_form/link"),
      DynamicFormField,
      DynamicFormConsolidatedInfo,
      DynamicFormArithmetic,
    },
    data() {
      return {
        tabNavigation: null,
      };
    },
    created() {
      this.debouncedCreateAnswerGroups = this.lodash.debounce(this.createAnswerGroup, 500, {
        leading: true,
        trailing: false,
      });
    },
    mounted() {
      if (this.currentAnswerGroupId === null) {
        this.createAnswerGroup();
      }
    },
    computed: {
      options() {
        if (this.shard) {
          const options = this.shard.options;
          if (options) {
            return options;
          }

          return {};
        }

        return {};
      },
      consolidateInfoOption() {
        if (this.options.consolidate_info) {
          return this.options.consolidate_info;
        }

        return {};
      },
      showConsolidateInfo() {
        if (this.consolidateInfoOption) {
          return this.consolidateInfoOption.active;
        }

        return false;
      },
      meanOption() {
        if (this.options.mean) {
          return this.options.mean;
        }

        return {};
      },
      showMean() {
        if (this.meanOption) {
          return this.meanOption.active;
        }

        return false;
      },
      varianceOption() {
        if (this.options.variance) {
          return this.options.variance;
        }

        return {};
      },
      showVariance() {
        if (this.varianceOption) {
          return this.varianceOption.active;
        }

        return false;
      },
      dutyCycleOption() {
        if (this.options.duty_cycle) {
          return this.options.duty_cycle;
        }

        return {};
      },
      showDutyCycle() {
        if (this.dutyCycleOption) {
          return this.dutyCycleOption.active;
        }

        return false;
      },
      dutyCycleDuration() {
        if (this.showDutyCycle) {
          let duration = this.lodash.get(this.shard.duty_cycle, "Duração", null);
          if (duration) {
            return duration;
          }
        }

        return null;
      },
      dutyCycleInterval() {
        if (this.showDutyCycle) {
          let interval = this.lodash.get(this.shard.duty_cycle, "Intervalo", null);
          if (interval) {
            return interval;
          }
        }

        return null;
      },
      showChildrenAsTabs() {
        if (this.options.show_children_as) {
          return this.options.show_children_as === "tabs";
        }

        return false;
      },
      showAddButton() {
        return this.options.multiple_answers && !this.readOnly;
      },
      showPresetButtons() {
        return this.presets.length > 0 && !this.readOnly;
      },
      presets() {
        if (this.shard) {
          if (this.shard.presets) {
            return this.shard.presets;
          }
        }

        return [];
      },
      links() {
        if (this.shard) {
          return this.lodash.orderBy(this.shard.links, ["options.position"], ["asc"]);
        }

        return [];
      },
      fields() {
        if (this.shard) {
          return this.lodash.orderBy(this.shard.fields, ["options.position"], ["asc"]);
        }

        return [];
      },
      answerGroups() {
        let answerGroups = this.shard.answer_groups;

        return this.lodash.orderBy(
          answerGroups,
          [
            function(o) {
              return this.$moment(o.created_at, "YYYY-MM-DD HH:mm:ss ZZ");
            }.bind(this),
          ],
          ["desc"]
        );
      },
      currentAnswerGroup() {
        const currentAnswerGroup = this.lodash.first(this.answerGroups);

        if (this.parentAnswerGroup) {
          if (this.options.multiple_answers) {
            return currentAnswerGroup;
          }

          return this.parentAnswerGroup;
        }

        return currentAnswerGroup;
      },
      currentAnswerGroupId() {
        if (this.currentAnswerGroup?.id) {
          return this.currentAnswerGroup.id;
        }

        return null;
      },
      oldAnswerGroups() {
        return this.lodash.filter(this.answerGroups, (answerGroup) => {
          return answerGroup.id !== this.currentAnswerGroup.id;
        });
      },
      consolidatedInfo() {
        if (this.showConsolidateInfo) {
          return this.shard.consolidate_info;
        }
        return {};
      },
    },
    methods: {
      createAnswerGroup(onSaveAnswer = false) {
        if (this.readOnly) return;

        if (this.options.multiple_answers) {
          return this.defaultCreateAnswerGroup(onSaveAnswer);
        }

        if (this.parentCreateAnswerGroup) {
          return this.parentCreateAnswerGroup(onSaveAnswer);
        }

        return this.defaultCreateAnswerGroup(onSaveAnswer);
      },
      defaultCreateAnswerGroup(onSaveAnswer = false) {
        if (this.readOnly) return;
        if (this.createAnswerGroupPromise) return this.createAnswerGroupPromise;

        if (this.currentAnswerGroup && onSaveAnswer === true) {
          return Promise.resolve(this.currentAnswerGroup);
        }

        if (this.currentAnswerGroup && !this.showAddButton) {
          return Promise.resolve(this.currentAnswerGroup);
        }

        this.createAnswerGroupPromise = this.apolloMutate({
          mutation: CREATE_DYNAMIC_FORM_ANSWER_GROUP,
          variables: {
            answerableId: this.answerableId,
            answerableType: this.answerableType,
            shardId: this.shard.id,
          },
        }).then(({ data }) => {
          return this.refreshAnswerGroups().then(() => {
            this.createAnswerGroupPromise = null;
            return data.createAnswerGroup;
          });
        });

        return this.createAnswerGroupPromise;
      },
      refreshAnswerGroups({ refreshAll = false } = {}) {
        return this.refreshForm({ shardId: this.shard.id, refreshAll });
      },
      async activePreset({ presetId }) {
        if (this.readOnly) return;

        await this.apolloMutate({
          mutation: ACTIVE_PRESET,
          variables: {
            answerableId: this.answerableId,
            answerableType: this.answerableType,
            presetId: presetId,
          },
        });

        await this.refreshAnswerGroups({ refreshAll: true });
      },
      async deleteAnswergroup({ answerGroupId }) {
        if (this.readOnly) return;
        if (!answerGroupId) return;

        await this.apolloMutate({
          mutation: DELETE_DYNAMIC_FORM_ANSWER_GROUP,
          variables: {
            answerGroupId: answerGroupId,
          },
        });

        await this.refreshAnswerGroups();
      },
      async saveAnswer({ answerGroupId = null, fieldId, value, tries = 0 }) {
        if (this.readOnly || value === "" || value===null) return;
        if (tries > 5) {
          return Promise.reject("Max attempts reached");
        }

        if (answerGroupId === null) {
          answerGroupId = this.currentAnswerGroupId;
        }

        if (answerGroupId) {
          await this.apolloMutate({
            mutation: require("@/graphql/dynamic_form/save_answer.gql"),
            variables: {
              answerGroupId: answerGroupId,
              fieldId: fieldId,
              value: value,
            },
          });

          await this.refreshAnswerGroups();
        } else {
          const answerGroup = await this.createAnswerGroup(true);

          await this.saveAnswer({
            answerGroupId: answerGroup.id,
            fieldId: fieldId,
            value: value,
            tries: tries + 1,
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
